import { useNavigate } from 'react-router-dom';

const SelectSchool = () => {
    const navigate = useNavigate();

    const handleInput = () => {

    }
    
    const handleSchool = () => {
        localStorage.setItem('lastschool', '123');
        navigate('/dashboard');
    };

    return (
        <>
            this is select school，please input school
            <button onClick={handleSchool}>Select School</button>
            <button></button>
        </>
    );
};

export default SelectSchool;